import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShareService } from '../../../services/share.service'
import { ApiserviceService } from '../../../../apiservice.service';
import { AppNotificationService } from '../../../services/app-notification.service';
import { SocketService } from '../../../../../../src/app/admin/socket.service';
import { Subscription } from 'rxjs';

 /**
 *
 * <strong>List of API using</strong>
 * <ol>
 * <li>estapi_module_type_notification_user_id_get</li>
 * <li>estapi_module_type_notification_user_id_patch</li>
 * </ol>
 *
 */

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['notification.component.css']
})
export class NotificationComponent implements OnInit, OnDestroy {
  notify_list: any = [];
  loader: boolean = false;
  private subs = new Subscription();
  constructor(private readonly share: ShareService,
    private readonly api: ApiserviceService,
     private readonly alert: AppNotificationService,
     private readonly socket: SocketService) {
    this.getTopNotifications();
  }

  getTopNotifications(offset = 0, limit = 20) {
    this.loader = true;
    let url = `deapp/notification/${this.api.user_id}?notification_status=sent,read&offset=${offset}&limit=${limit}&sort_by=added_date`;
    const topNotifiSub = this.api.getEmsData(url).subscribe({
      next: (res) => {
        this.loader = false;
        if (res && Array.isArray(res)) {
          this.notify_list = res;
          console.log("notify_list",this.notify_list);
        }

      },
      error: () => {
        this.loader = false;
      },
    });
    this.subs.add(topNotifiSub);
  }
  markAsRead(n) {
    if (n.email_status != 'read') {
      let user_id = this.api.user_id;
      let url = `deapp/notification/${user_id}`;
      let data = {
        "email_status": "read",
        "notification_id": n.notification_id,
        "updated_by": this.api.user_id
      }
      const markAsReadSub = this.api.patchEmsData(url, data).subscribe((data:any) => {
        this.getTopNotifications();
        this.alert.getCount();
        if(this.share.notify_obj){
          this.share.notify_obj.getNotifications();
        }
      });
      this.subs.add(markAsReadSub);
    }
  }

  markAllAsRead(){
    let user_id = this.api.user_id;
    let url = `deapp/notification/${user_id}`;
    let data = {
      "mark_all_as_read": true,
      "updated_by": this.api.user_id,
      "notification_id": 0
    };
    const markAllAsRead = this.api.patchEmsData(url, data).subscribe({
      next: ()=>{
        this.getTopNotifications();
        this.alert.getCount();
        if(this.share.notify_obj){
          this.share.notify_obj.getNotifications();
        }
      },
      error: (err) => {
        console.log("Mark all as read error:", err);
      }
    });

    this.subs.add(markAllAsRead);
  }

  overlay_off() {
    this.share.adminComp.overlay_off();
  }

  getDate(v) {
    let date = new Date(v);
    let month = date.getMonth() + 1;
    let format = date.getDate() + '-' + month + '-' + date.getFullYear();
    return format;
  }
  getTime(v) {
    let date = new Date(v);
    let format = date.getHours() + ':' + date.getMinutes();
    return format;
  }
  ngOnInit() {
        ///getting data from socket
 ///getting data from socket

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}

